import { cardRef, cellTarget, defineGameCard, onResolve, planningTargets, targetStep, unitTarget, } from '../authoring/index.js';
import { growthOf, hasTrait, isLiveOnBoard, plannedCellId, plannedUnitId, removeGrowth, tableOf, } from './plant-helpers.js';
/**
 * Буйное цветение: выбранное Растение тратит свой Рост, переезжает в явно
 * выбранную свободную ячейку соседней локации, а в прежней ячейке появляется
 * Лист. Оба planning-step видимы игроку и повторно валидируются при resolution.
 */
export const RampantBloomCard = defineGameCard({
    id: 'rampant_bloom',
    gameplay: {
        type: 'SPELL',
        cost: 2,
        planning: planningTargets((context, previous) => {
            const selected = previous.find((step) => step.stepId === 'target')?.selection[0];
            const plant = selected?.kind === 'unit'
                ? context.units.find((unit) => unit.instanceId === selected.instanceId)
                : undefined;
            return [
                targetStep('target', unitTarget({
                    side: 'ally',
                    cardinality: { min: 1, max: 1 },
                    where: ({ unit }) => unit.traits.includes('PLANT'),
                })),
                targetStep('destination', cellTarget({
                    side: 'ally',
                    occupancy: 'empty',
                    cardinality: { min: 1, max: 1 },
                    where: ({ cell }) => plant !== undefined
                        && Math.abs(cell.tableId - tableOf(plant.cellId)) === 1,
                })),
            ];
        }),
    },
    presentation: {
        name: 'Буйное цветение',
        description: 'Выбранное ваше Растение тратит 1 Рост. Переместите его в свободную ячейку соседней локации и создайте Лист в его бывшей ячейке.',
        glyph: {
            colors: ['#D97082', '#FFBABB', '#4C613D', '#10213A', '#764D2D'],
            rows: [
                '....................',
                '.........11.........',
                '.......112211.......',
                '......12222221......',
                '.......112211.......',
                '.........11.........',
                '.....333.3..333.....',
                '.....33333.3333.....',
                '......3333.333......',
                '.........33.........',
                '..........3.........',
                '..........3.........',
                '.......444344.......',
                '......45553554......',
                '......455555554.....',
                '......455454544.....',
                '......445555444.....',
                '.......4554444......',
                '........44444.......',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('plant_leaf')],
    abilities: [
        onResolve({
            source: 'card_effect',
            dependencies: [cardRef('plant_growth')],
            run: (ctx) => {
                const targetId = plannedUnitId(ctx, 'target');
                const destinationId = plannedCellId(ctx, 'destination');
                const target = targetId === undefined ? null : ctx.q.instance(targetId);
                if (ctx.self === undefined || !isLiveOnBoard(target)
                    || target.controllerId !== ctx.self.controllerId
                    || !hasTrait(ctx, target.id, 'PLANT')
                    || destinationId === undefined
                    || growthOf(ctx, target.id) < 1)
                    return;
                const destination = ctx.q.cell(destinationId);
                if (destination === null
                    || destination.occupantId !== null
                    || destination.side !== ctx.q.player(target.controllerId).side
                    || Math.abs(destination.tableId - tableOf(target.cellId)) !== 1)
                    return;
                const formerCellId = target.cellId;
                removeGrowth(ctx, target.id, 1, 'bloom');
                ctx.ops.moveUnit(target.id, destination.id);
                ctx.ops.tryCreateToken('plant_leaf', target.controllerId, formerCellId);
            },
        }),
    ],
    ui: {
        mechanics: ['growth'],
        planning: { steps: {
                target: { label: 'Выберите своё Растение с Ростом' },
                destination: { label: 'Выберите свободную ячейку соседней локации' },
            } },
    },
});
//# sourceMappingURL=rampant_bloom.js.map